module.exports = __webpack_public_path__ + "img/60.bdd7bc2d.png";